/**
 * Created by rhinov15 on 29/01/2016.
 */
/**
 * STate allowing joineries to be added to the plan
 */

import { ActionState, ActionStateEnum, IdleConstruction } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { JoineryNode } from "../../plan/EntityNodes/JoineryNode";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { CeilingBox, Commands, Door, EntityDefaultPropertiesManager, EntityFactory, Events, eventsManager, Joinery, joineryManager, math, SavaneConstants, SceneConstants, TechnicalElement, Velux } from "@rhinov/savane-js";

declare var cc: any;

declare var $: any;

export class AddJoineryState extends ActionState {

    state: number = ActionStateEnum.addJoinery;
    _joinery: Joinery;
    // This will store the joinery was moved (to create a command only the joinery was moved and not create a useless command)
    _hasMoved: boolean = false;
    _node: JoineryNode;
    lock_position: any = [];
    // Auto snap with another joinery distance threshold
    snapToOtherJoineryDistance: number = 5;
    tolerance: number = 20;
    shiftPressed: boolean = false;

    // The edition isn't done yet
    editionDone: boolean = false;

    constructor(joinery: Joinery) {
        // Parent class is ActionState
        super();
        // Save savane joinery entity to appy changes
        this._joinery = joinery;
        
        // Start temporary state of the joinery so changes are applied to this temporary entity and not to the real entity (easier to undo before the state ends)
        this._joinery.startTemporary();
        // Add a new entity to the entity manager (this will create the joinery node)
        EntityManager.getInstance().addEntity(this._joinery);
        // Get and store the graphic node of the joinery
        this._node = EntityManager.getInstance().getNode(this._joinery) as JoineryNode;
        // The joinery node is selected
        this._node.setSelected(true);
        // But not visible yet
        this._node.setVisible(false);
    }

    fromVoiceRecognition(cursorPosition: math.vec3) {
        this.moveMouseCursor(cursorPosition);
    }

    // Mouse click done, nothing to do
    mouseClickDown(cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: any[], mouseButton: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }

        return null;
    }

    // Mouse click up, let's try to place the joinery on the plan
    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: any[], mouseButton: number) {
        // Edition has ended
        this.editionDone = true;

        // New state to go to
        var nextState;
        // We will go to idleConstruction or addJoineryState depending on shift pressed or not
        if (!this.shiftPressed) {
            nextState = new IdleConstruction();
        }
        else {
            nextState = new AddJoineryState(EntityFactory.getInstance().cloneEntity(this._joinery, true) as Joinery);
        }
        // Informt there there is a plan state change
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, nextState.getAction());

        // Get PlanManager for further use
        var planManager = PlanManager.getInstance();
        // If the joinery is valid (i.e. correctly placed on a wall) and the joinery was moved (not same position)
        if (this._joinery.isValid(planManager.world.currentScene!.currentFloor!) && this._hasMoved) {
            // If velux, auto update joinery floor height
            if (this._joinery.joineryType === SceneConstants.JoineryType.velux) {
                (this._joinery as Velux).updateFloorHeight();
            }
            else {
                if (this._joinery.wall && this._joinery.wall.rooms.length > 0) {
                    var maxRoomFloorHeight = this._joinery.wall.rooms[0].floorHeight;

                    for (var i = 1 ; i < this._joinery.wall.rooms.length ; i++) {
                        if (maxRoomFloorHeight < this._joinery.wall.rooms[i].floorHeight) {
                            maxRoomFloorHeight = this._joinery.wall.rooms[i].floorHeight;
                        }
                    }

                    this._joinery.floorHeight += maxRoomFloorHeight;
                }
            }
            // Joinery is valid, start create command
            this._joinery.saveAndEndTemporary();
            planManager.executeCommand(new Commands.AddJoineryCommand(this._joinery));
            planManager.joineriesLength[this._joinery.joineryType] = this._joinery.length;

            // Open tulip of this joinery to access setting immediatly
            PlanManager.getInstance().updateItemsSelected([this._joinery], false, true);

            // Tutorial start
            eventsManager.instance.dispatch(Events.PLAN_TUTO_START, 24);
            // End tutorial
        }
        else {
            // Update rolling shutter position
            if (this._joinery.wall !== null) {
                this.updateRollingShutterPosition(this._joinery.wall.thickness);
            }
            //Joinery is invalid remove node
            EntityManager.getInstance().removeEntity(this._joinery);
        }
        return nextState;
    }

    updateRollingShutterPosition(thickness: number) {
        for (var j = 0; j < this._joinery.children.length; j++) {
            var joinChild = this._joinery.children[j];

            if (joinChild.entityType === SceneConstants.EntityType.TechnicalElement &&
                (joinChild as TechnicalElement).objectId === SceneConstants.TechnicalElementType.ceilingBox &&
                (joinChild as CeilingBox).ceilingBoxType === SceneConstants.CeilingBoxType.rollingShutter) {
                (joinChild as any).length = this._joinery.length;

                var position = math.vec3.create();

                if (this._joinery.orientation) {
                    math.vec3.set(position, 0, -thickness / 2, this._joinery.height + this._joinery.floorHeight);
                } else {
                    math.vec3.set(position, 0, thickness / 2, this._joinery.height + this._joinery.floorHeight);
                }
                if (this._joinery.transom) {
                    position[2] = this._joinery.transomHeight;
                }
                joinChild.transform.localPosition = position;
            }
        }
    }

    // Mouse cursor movement (takes the current cursor position and hovered walls if any)
    moveMouseCursor(cursorPosition: math.vec3, wallsSelected?: any[], planpos?: any) {
        eventsManager.instance.dispatch(Events.STOP_UPDATING_ENVS);
        super.moveMouseCursor(cursorPosition, wallsSelected, planpos);
        // Redraw Node
        var node = EntityManager.getInstance().getNode(this._joinery);
        if (node !== null) {
            node.needRedraw = true;
        }

        // The entity has moved
        this._hasMoved = true;
        // Show the joinery if it has moved
        this._node.setVisible(this._hasMoved);

        // Give the focus to the game canvas
        $('#gameCanvas').focus();

        if (this._joinery.joineryType === SceneConstants.JoineryType.velux) {
            var walls = PlanManager.getInstance().world.currentScene!.currentFloor!.walls;
            for (var i = 0; i < walls.length; i++) {
                var slope = walls[i].getSlope(this._joinery);

                if (slope !== 0) {
                    this._joinery.wall = walls[i];
                    this._joinery.orientation = (slope === 1);
                    break;
                }
            }

            if (this._joinery.wall === null) {
                // No slope underneath the joinery for the moment
                this.lock_position = [];
                EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(this._joinery);
            }

            this._joinery.position = cursorPosition;
        }
        else {
            // If a wall is hovered and only one and not on the corner of this wall
            if (wallsSelected && wallsSelected.length === 1 && !wallsSelected[0].isCorner(cursorPosition, SavaneConstants.PositionTolerance)) {
                // Assign the wall owning the joinery to the joinery
                this._joinery.wall = wallsSelected[0];
                // Set joinery orientation
                this._joinery.orientation = PlanManager.getInstance()._uiState.orientation;
                // Compute the max size for the joinery and assign it is it is more constraining than the current size
                var maxLength = joineryManager.findMaxJoineryLength(this._joinery);

                // If the max length was determined correctly (if 0 then impossible to determine)
                if (maxLength > 0) {
                    // Joinery bigger than available space ? Reduce its length automatically
                    if (this._joinery.length > maxLength) {
                        // But beware not to assign a too constraining size (i.e. size 0 for instance)
                        if (maxLength < SceneConstants.MinimalJoineryLength) {
                            this._joinery.length = SceneConstants.MinimalJoineryLength;
                        }
                        else {
                            // Leave 1cm margin for the new length
                            this._joinery.length = maxLength - 10;
                        }
                    }
                }

                // Compute joinery height depending on wall height
                if (this._joinery.floorHeight + this._joinery.height > wallsSelected[0].height) {
                    this._joinery.floorHeight += wallsSelected[0].height - (this._joinery.floorHeight + this._joinery.height);
                    // Do not go under a floor height of 0 and potentially recompute joinery height
                    if (this._joinery.floorHeight < 0) {
                        this._joinery.floorHeight = 0;
                        this._joinery.height = this._joinery.wall.height;
                    }
                }

                // For doors... check handle size depending on which side of the wall is the smallest (assign the handle side to the smallest distance between joinery and adjacent wall as default)
                if (this._joinery.joineryType == SceneConstants.JoineryType.door || this._joinery.joineryType == SceneConstants.JoineryType.frontDoor || this._joinery.joineryType == SceneConstants.JoineryType.frenchWindow) {
                    // Only set the door opening side if the door has one door and default opening mode
                    if ((!(this._joinery as Door).openingMode || (this._joinery as Door).openingMode === SceneConstants.OpeningMode.mode_default) && ((this._joinery as Door).nbDoors === 1)) {
                        var joineryToBegin = math.vec3.distance(this._joinery.position, this._joinery.wall.begin);
                        var joineryToEnd = math.vec3.distance(this._joinery.position, this._joinery.wall.end);

                        if (joineryToBegin < joineryToEnd) {
                            (this._joinery as Door).handleSide = SceneConstants.HandleSide.handle_left;
                        }
                        else {
                            (this._joinery as Door).handleSide = SceneConstants.HandleSide.handle_right;
                        }
                    }
                }
            }
            else {
                // No wall underneath the joinery for the moment
                this.lock_position = [];
                EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(this._joinery);
            }

            if (PlanManager.getInstance().snapEnabled || (this.lock_position.length == 0 || math.vec3.distance(cursorPosition, this._joinery.position) > this.tolerance * 10)) {
                this._joinery.position = cursorPosition;
                this.lock_position = [];
            }

            this.updateRollingShutterPosition(0);
        }

        //Snap
        if (this._joinery.wall && PlanManager.getInstance().snapEnabled) {
            joineryManager.snap(this._joinery);
        }

        return null;
    }

    mouseIdle(cursorPosition: math.vec3, hoverEntities: any[], dt: number): ActionState | null {
        return null;
    }

    // Joinery addition cancelled, return to IdleConstruction
    mouseClickCancelled(cursorPosition: math.vec3) {
        PlanManager.getInstance().updateItemsSelected(null);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
        return new IdleConstruction();
    }

    // Delete key pressed, remove the current joinery from the scene using an existing command
    actionDelete() {
        var joineries = PlanManager.getInstance().selectedJoineries
        if (joineries) {
            PlanManager.getInstance().executeCommand(new Commands.DeleteJoineriesCommand(joineries));
        }
    }

    // Keyboard management
    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean) {
        // Escape pressend, then cancel the joinery addition
        if (keyCode === cc.KEY.escape) {
            PlanManager.getInstance().updateItemsSelected(null);
            eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
            return new IdleConstruction();
        }

        if (keyCode == cc.KEY.shift) {
            this.shiftPressed = true;
        }

        if (keyCode === cc.KEY.s) {
            PlanManager.getInstance().toggleSnap();
        }

        // TAB key, reset/restore joinery default values (width, height...) in case the joinery size was changed while moving
        if (keyCode === cc.KEY.tab || keyCode === cc.KEY.q) {
            EntityDefaultPropertiesManager.getInstance().resetJoineryDefaultProperties(this._joinery.joineryType);
            EntityDefaultPropertiesManager.getInstance().convertJoineryToDefaultProperties(this._joinery);
        }

        // Delete and backspace management, delete the current joinery
        if (keyCode === cc.KEY.Delete || keyCode === cc.KEY.backspace) {
            this.actionDelete();
        }

        return null;
    }

    keyUnPressed(keyCode: number, ctrl?: boolean, maj?: boolean) {
        if (keyCode == cc.KEY.shift) {
            this.shiftPressed = false;
        }

        return null;
    }

    // Return action name from global enum
    getAction(): number {
        return ActionStateEnum.addJoinery;
    }

    onButton(buttonId: number): boolean {
        return true;
    }

    snapClick() {
        return new IdleConstruction();
    }

    // State destruction
    dispose() {
        if (this._joinery.wall !== null) {
            this.updateRollingShutterPosition(this._joinery.wall.thickness);
        }

        if (!this.editionDone) {
            EntityManager.getInstance().removeEntity(this._joinery);
            GameObjectManager.deleteJoinery(this._joinery.id);
        }
    }

    mouseHoverWall(wallHovered: any, cursorPosition: math.vec3): boolean {
        return true;
    }

    mouseLeaveHoverWall(wallHovered: any, cursorPosition: math.vec3): boolean {
        return true;
    }
}

